import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { withSubscriptions } from 'Components/WithSubscriptions';
import { useSelectPlans } from 'Hooks/useSelectPlan';
import { CenterFrameLayout } from 'Layouts';
import { SheerIdBanner } from 'Features/SheerIdPromoBanner/SheerIdBanner';
import { PlanSelection } from 'Features/Plans/PlanSelection/PlanSelection';
import { isFirstResponderChurned, isMilitaryChurned } from 'Utils/SheerIdHelpers';
import './SignUpPlansContainer.css';

const SignUpPlansComponent = () => {
  const selectablePlans = useSelectPlans({ isPlansCopyV3: true });

  const { selectedPlan } = useSelector((s) => s.plans);
  const { enableSheerIdBanner } = useSelector((s) => s.appConfig.defaultConfig);
  const subscription = useSelector((s) => s.subscription);
  const { isAuthenticated } = useSelector((s) => s.user);
  const routes = useSelector((s) => s.appConfig.routes);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sheerIdSKU = localStorage.getItem('sheerVerificationPackageSKU');

  const isSheerIdChurned =
    isFirstResponderChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails) ||
    isMilitaryChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails);

  const showSheerIdBanner = useMemo(
    () => enableSheerIdBanner && !!selectablePlans.length && !isSheerIdChurned,
    [enableSheerIdBanner, selectablePlans, isSheerIdChurned]
  );

  useEffect(() => {
    trackEvent(TRACKING_ENUMS.EVENT_PLAN_SELECT_START);
  }, []);

  return (
    <CenterFrameLayout
      title="Choose a Plan"
      showLoader={!selectablePlans.length}
      modernLayout
      customClass="signUpPlansContainer"
    >
      {showSheerIdBanner && <SheerIdBanner />}
      <PlanSelection plans={selectablePlans} selectedPlan={selectedPlan} />
    </CenterFrameLayout>
  );
};
export const SignUpPlansContainer = withSubscriptions(SignUpPlansComponent);
